import React, { useState } from "react";
import { Variants } from "../index";

import "./index.scss";


export default ({ setDelimiter, form, variants, variantsQuantityError, setVariants }) => {

	const [variantsModal, setVariantsModal] = useState(false);
	const isSerials = form.values.type === "SERIALS";
	const isLicense = form.values.licensing_enabled;

	return <div className="product-form-main-back pb-3">

		<div className="paylixecommerce-note-big mt-0 mb-3">
			Now add options for your product. At least 2 options must be added.
		</div>

		<Variants
			setDelimiter={setDelimiter}
			currency={typeof form.values.currency === "string" ? form.values.currency : form.values.currency.value}
			setModal={(value) => setVariantsModal(value)}
			modal={variantsModal}
			fields={variants}
			updateFields={setVariants}
			form={form}
			isSerials={isSerials}
			isLicense={isLicense}
		/>

		{variantsQuantityError ? <div className="invalid-feedback d-flex w-100">{variantsQuantityError}</div> : null}
	</div>
}